/* Novistore Warenkorb-Drawer: Gratis-Versand-Balken, Warenkorbfueller, Rabattcode.
   Nach jeder Aenderung wird "cart:refresh" ausgeloest; das Theme rendert den Drawer
   (sections/cart-drawer.liquid) und den Zaehler im Header neu. */
(function () {
  if (window.nvCartDrawerLoaded) return;
  window.nvCartDrawerLoaded = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /* ---------- Gratis-Versand-Balken: von altem auf neuen Stand animieren ---------- */
  var lastPct = null;
  customElements.get('nv-ship-bar') || customElements.define('nv-ship-bar', class extends HTMLElement {
    connectedCallback() {
      var fill = this.querySelector('.nv-cd-ship__fill');
      var pct = parseFloat(this.dataset.pct) || 0;
      if (!fill) return;
      if (lastPct !== null && lastPct !== pct) {
        fill.style.transition = 'none';
        fill.style.width = lastPct + '%';
        fill.getBoundingClientRect();
        fill.style.transition = '';
        requestAnimationFrame(function () { fill.style.width = pct + '%'; });
      }
      lastPct = pct;
    }
  });

  /* ---------- Warenkorbfueller ---------- */
  var fillerCache = {};   // URL -> HTML
  var fillerPending = {}; // URL -> Promise

  /* Quellen: Shopify-Empfehlungen zum ersten Artikel und die Fallback-Kollektion (Bestseller).
     Die Bestseller liefern die guenstigen Kleinartikel, mit denen die Gratis-Lieferung erreicht wird. */
  function fillerUrls(productId) {
    var fallback = root + '?section_id=nv-cart-filler';
    return productId
      ? [root + 'recommendations/products?product_id=' + productId + '&limit=10&intent=related&section_id=nv-cart-filler', fallback]
      : [fallback];
  }

  var MAX_CARDS = 10, MAX_CLOSERS = 3;

  function loadFiller(url) {
    if (fillerCache[url]) return Promise.resolve(fillerCache[url]);
    if (!fillerPending[url]) {
      fillerPending[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var list = doc.querySelector('[data-nv-filler]');
          fillerCache[url] = list ? list.innerHTML : '';
          delete fillerPending[url];
          return fillerCache[url];
        })
        .catch(function () { delete fillerPending[url]; return ''; });
    }
    return fillerPending[url];
  }

  /* Hinweis "Damit ist die Lieferung gratis", wenn der Artikel die fehlende Summe deckt */
  function markFree(card, remaining) {
    var free = card.querySelector('.nv-cdf__free');
    if (free) free.hidden = !(remaining > 0 && Number(card.dataset.price) >= remaining);
  }

  var arrowL = '<svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true"><path d="M12.5 5l-5 5 5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var arrowR = '<svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true"><path d="M7.5 5l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  customElements.get('nv-cart-filler') || customElements.define('nv-cart-filler', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      Promise.all(fillerUrls(this.dataset.productId).map(loadFiller))
        .then(function (htmls) { if (self.isConnected) self.render(htmls); });
    }

    /* Reihenfolge: zuerst bis zu 3 der guenstigsten Artikel, mit denen der Warenkorb die Gratis-Lieferung
       erreicht (markiert), danach die Empfehlungen, zuletzt die Bestseller. Doppelte und Artikel im Warenkorb fallen weg. */
    render(htmls) {
      var inCart = (',' + (this.dataset.cartPids || '') + ',');
      var remaining = Number(this.dataset.remaining) || 0;
      var seen = {};
      var all = [];
      htmls.forEach(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        tmp.querySelectorAll('.nv-cdf__card').forEach(function (card) {
          var id = card.dataset.productId;
          if (seen[id] || inCart.indexOf(',' + id + ',') > -1) return;
          seen[id] = true;
          all.push(card);
        });
      });
      var closers = [];
      if (remaining > 0) {
        closers = all
          .filter(function (c) { return Number(c.dataset.price) >= remaining; })
          .sort(function (a, b) { return Number(a.dataset.price) - Number(b.dataset.price) || all.indexOf(a) - all.indexOf(b); })
          .slice(0, MAX_CLOSERS);
      }
      var cards = closers.concat(all.filter(function (c) { return closers.indexOf(c) < 0; })).slice(0, MAX_CARDS);
      if (!cards.length) { this.hidden = true; return; }
      this.remaining = remaining;
      cards.forEach(function (c) { markFree(c, remaining); });

      this.innerHTML =
        '<div class="nv-cdf-head">' +
          '<p class="nv-cdf-head__title"></p>' +
          '<div class="nv-cdf-head__nav">' +
            '<button type="button" data-dir="-1" aria-label="Vorheriges Produkt">' + arrowL + '</button>' +
            '<button type="button" data-dir="1" aria-label="Nächstes Produkt">' + arrowR + '</button>' +
          '</div>' +
        '</div>' +
        '<div class="nv-cdf"></div>';
      this.querySelector('.nv-cdf-head__title').textContent = this.dataset.heading || '';
      var track = this.querySelector('.nv-cdf');
      cards.forEach(function (c) { track.appendChild(c); });
      this.hidden = false;
      this.bind(track);
    }

    bind(track) {
      var self = this;
      /* Pfeile sind immer aktiv: am Ende springt "weiter" zum Anfang, am Anfang "zurueck" zum Ende.
         (Die Breiten werden erst beim Klick gemessen – der Drawer ist beim Rendern oft noch versteckt.) */
      var nav = this.querySelector('.nv-cdf-head__nav');
      if (track.querySelectorAll('.nv-cdf__card').length < 2) nav.hidden = true;
      this.querySelectorAll('.nv-cdf-head__nav button').forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = Number(b.dataset.dir);
          var card = track.querySelector('.nv-cdf__card');
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          var step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
          var max = track.scrollWidth - track.clientWidth;
          var target;
          if (dir > 0 && track.scrollLeft >= max - 2) target = 0;
          else if (dir < 0 && track.scrollLeft <= 2) target = max;
          else target = Math.round(track.scrollLeft / step + dir) * step;
          track.scrollTo({ left: Math.max(0, Math.min(max, target)), behavior: 'smooth' });
        });
      });

      track.addEventListener('change', function (e) {
        var sel = e.target.closest('select');
        if (!sel) return;
        var card = sel.closest('.nv-cdf__card');
        var opt = sel.options[sel.selectedIndex];
        card.querySelector('.nv-cdf__add').dataset.variantId = sel.value;
        card.querySelector('.nv-cdf__final').innerHTML = opt.dataset.price || '';
        card.querySelector('.nv-cdf__compare').innerHTML = opt.dataset.compare || '';
        if (opt.dataset.cents) card.dataset.price = opt.dataset.cents;
        markFree(card, self.remaining);
      });

      track.addEventListener('click', function (e) {
        var btn = e.target.closest('.nv-cdf__add');
        if (!btn) return;
        btn.setAttribute('aria-busy', 'true');
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.d && res.d.description);
            refreshCart();
          })
          .catch(function () {
            btn.removeAttribute('aria-busy');
            btn.classList.add('is-error');
            btn.querySelector('span').textContent = 'Nicht verfügbar';
          });
      });
    }
  });

  /* ---------- Rabattcode ---------- */
  function updateDiscount(codes) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.json(); });
  }

  customElements.get('nv-discount-code') || customElements.define('nv-discount-code', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      var toggle = this.querySelector('.nv-cd-code__toggle');
      var panel = this.querySelector('.nv-cd-code__panel');
      var input = this.querySelector('.nv-cd-code__input');
      var apply = this.querySelector('.nv-cd-code__apply');
      var msg = this.querySelector('.nv-cd-code__msg');
      var current = (this.dataset.codes || '').split(',').filter(Boolean);

      if (window.nvCdCodeOpen) {
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }
      var f = window.nvCdCodeMsg;
      if (f) {
        window.nvCdCodeMsg = null;
        msg.textContent = f.text;
        msg.classList.toggle('is-ok', !!f.ok);
        msg.hidden = false;
      }

      toggle.addEventListener('click', function () {
        var open = panel.hidden;
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        window.nvCdCodeOpen = open;
        if (open) input.focus();
      });

      function setFlash(text, ok) {
        window.nvCdCodeMsg = { text: text, ok: ok };
      }

      function submit() {
        var code = input.value.trim();
        if (!code) { input.focus(); return; }
        if (current.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) > -1) {
          msg.textContent = 'Dieser Code ist bereits eingelöst.';
          msg.classList.remove('is-ok');
          msg.hidden = false;
          return;
        }
        apply.setAttribute('aria-busy', 'true');
        updateDiscount(current.concat(code))
          .then(function (cart) {
            var found = (cart.discount_codes || []).filter(function (d) {
              return d.code.toLowerCase() === code.toLowerCase();
            })[0];
            if (found && found.applicable) {
              setFlash('Rabattcode «' + found.code + '» wurde eingelöst.', true);
              refreshCart();
            } else {
              /* ungueltigen Code wieder entfernen, gueltige behalten */
              var keep = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
              return updateDiscount(keep).then(function () {
                apply.removeAttribute('aria-busy');
                msg.textContent = 'Dieser Code ist ungültig oder für deinen Warenkorb nicht anwendbar.';
                msg.classList.remove('is-ok');
                msg.hidden = false;
              });
            }
          })
          .catch(function () {
            apply.removeAttribute('aria-busy');
            msg.textContent = 'Der Code konnte nicht geprüft werden. Bitte versuche es erneut.';
            msg.classList.remove('is-ok');
            msg.hidden = false;
          });
      }

      apply.addEventListener('click', submit);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submit(); }
      });

      this.querySelectorAll('.nv-cd-code__remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          btn.disabled = true;
          var rest = current.filter(function (c) { return c !== btn.dataset.code; });
          updateDiscount(rest).then(refreshCart, refreshCart);
        });
      });
    }
  });
})();
